import { render } from "./ConfirmAmount.vue?vue&type=template&id=e580c722&scoped=true"
import script from "./ConfirmAmount.vue?vue&type=script&lang=js"
export * from "./ConfirmAmount.vue?vue&type=script&lang=js"

import "./ConfirmAmount.vue?vue&type=style&index=0&id=e580c722&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e580c722"]])

export default __exports__